import { AccountIconSVG } from 'components/iconsSVG/accountIcon';
import { Button } from 'components/ui/button';
import { useI18n } from 'context/i18n';

type MobileAccountButtonProps = {
  onPress: () => void;
};
export function MobileAccountButton({ onPress }: MobileAccountButtonProps) {
  const { t, profileData } = useI18n();
  if (profileData.global_e) {
    return null;
  }
  return (
    <Button onPress={onPress} variant="none" className="accountButton md:hidden">
      <span className="flex items-center">
        <AccountIconSVG className="mr-2.5 h-5 text-copy" />
        <span className="font-moderne text-xs capitalize nnormal:text-base camper:underline">{t('mi.cuenta', 'mi.cuenta')}</span>
      </span>
    </Button>
  );
}
